var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-match-found" }, [
    _c("div", { staticClass: "no-contest-thumbnail" }, [
      _c("img", {
        attrs: {
          src:
            _vm.CFG_WIDGET_URL_BASE +
            "/static-assets/images/cssimages/no-contest-cham.png",
          alt: "",
        },
      }),
    ]),
    _vm._v(" "),
    _vm.toShow === "no_matches"
      ? _c("div", { staticClass: "no-contest-text" }, [
          _c("p", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.translations.no_matches_text_1)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.translations.no_matches_text_2)),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.toShow === "no_series"
      ? _c("div", { staticClass: "no-contest-text" }, [
          _c("p", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.translations.no_series_text_1)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.translations.no_series_text_2)),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.toShow === "no_feed"
      ? _c("div", { staticClass: "no-contest-text" }, [
          _c("p", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.translations.no_feed_text_1)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.translations.no_feed_text_2)),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.toShow === "no_lineup"
      ? _c("div", { staticClass: "no-contest-text" }, [
          _c("p", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.translations.no_lineup_text_1)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.translations.no_lineup_text_2)),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.toShow === "no_match_tips_list"
      ? _c("div", { staticClass: "no-contest-text" }, [
          _c("p", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.translations.no_match_tips_list_text_1)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.translations.no_match_tips_list_text_2)),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.toShow === "custom_message"
      ? _c("div", { staticClass: "no-contest-text" }, [
          _c("p", { staticClass: "text" }, [_vm._v(_vm._s(_vm.plainMsg))]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }